import React, { useCallback } from 'react'
import { ContactUsStyles } from './Style'
import { Button, SvgIcon } from '@mui/material'
import { ReactComponent as ContactUsIcon } from 'assets/icons/ContactUs.svg';
import { useAlert } from 'components/Alerts/hooks';
import { alerts as alertKeys } from 'keys';
import { useSelector } from 'react-redux';

const ContactUsButton = () => {
    const { setAlerts } = useAlert()

    const openContactUsAlert = useCallback(() => {
        setAlerts(alertKeys.contactUs, true)
    }, [])

    return (
        <ContactUsStyles>
            <Button color="dark" variant='contained' onClick={openContactUsAlert}>
                <SvgIcon fontSize="small" component={ContactUsIcon} inheritViewBox />
                <div className='contact-us-text'>
                    {"שאלה?  הערה?  אנחנו רוצים לשמוע ממך"}
                </div>
            </Button>
        </ContactUsStyles>
    )
}

export default ContactUsButton